<template>
  <form
    action=""
    @submit.prevent="onSubmit"
  >
    <div
      :class="$style['inner']"
      class="gray-background-inner-column input-box"
    >
      <div :class="$style['left-column']">
        <ds-label>
          <span slot="content">
            Adres
          </span>
        </ds-label>
        <ds-input
          v-model="address"
          :validate-rules="{required: true}"
          placeholder="Adres IP lub domena"
          name="ip_address"
          class="ping-inp"
        />

        <ds-label>
          <span slot="content">
            Type
          </span>
        </ds-label>

        <ds-select
          v-model="type"
          :options="typeOptions"
          name="type"
        />

        <ds-label>
          <span slot="content">
            Resolver
          </span>
        </ds-label>

        <ds-select
          v-model="resolver"
          :options="resolverOptions"
          name="resolver"
        />

        <div v-if="resolver === 'custom'">
          <ds-label>
            <span slot="content">
              Custom resolver IP
            </span>
          </ds-label>
          <ds-input
            v-model="customResolver"
            :validate-rules="{required: resolver === 'custom', ip: true}"
            placeholder="Adres IP"
            name="custom resolver ip"
          />
        </div>

        <ds-label>
          <span slot="content">
            Options
          </span>
        </ds-label>

        <ds-checkbox
          v-for="option in dnsOptions"
          :key="option.value"
          :checked="option.selected"
          :show-error-box="false"
          :id="option.key"
          :class="$style['checkbox-wrapper']"
          :name="option.name"
          @onChecked="onChecked(option)"
        >
          <span slot="content">
            {{ option.displayName }}
          </span>
        </ds-checkbox>

      </div>
      <div style="align-self: flex-start; margin-top: 20px;">
        <ds-button class="column">START</ds-button>
      </div>
    </div>
  </form>
</template>

<script>
import dnsRecords from "./dns-records";

export default {
  name: "DnsToolForm",
  data() {
    return {
      address: "",
      type: "A",
      resolver: "8.8.4.4",
      customResolver: "",
      typeOptions: {
        default: {
          key: "A",
          value: "A"
        },
        data: dnsRecords
      },
      dnsOptions: [
        {
          name: "additional",
          displayName: "Stats",
          selected: false
        },
        {
          name: "trace",
          displayName: "Trace",
          selected: false
        },
        {
          name: "short",
          displayName: "short",
          selected: false
        },
        {
          name: "norec",
          displayName: "No recursive",
          selected: false
        },
        {
          name: "dnssec",
          displayName: "DNSSEC",
          selected: false
        }
      ],
      resolverOptions: {
        default: {
          key: "8.8.4.4",
          value: "Default"
        },
        data: [
          {
            key: "8.8.4.4",
            value: "Default"
          },
          {
            key: "165.87.13.129",
            value: "AT&T (US)"
          },
          {
            key: "1.1.1.1",
            value: "CloudFlare"
          },
          {
            key: "8.26.56.26",
            value: "Comodo (US)"
          },
          {
            key: "8.8.8.8",
            value: "Google"
          },
          {
            key: "168.95.1.1",
            value: "HiNet (TW)"
          },
          {
            key: "208.67.222.222",
            value: "OpenDNS"
          },
          {
            key: "9.9.9.9",
            value: "Quad9"
          },
          {
            key: "144.217.51.168",
            value: "Securolytics (CA)"
          },
          {
            key: "195.129.12.122",
            value: "UUNET (CH)"
          },
          {
            key: "192.76.144.66",
            value: "UUNET (DE)"
          },
          {
            key: "158.43.240.3",
            value: "UUNET (UK)"
          },
          {
            key: "198.6.100.25",
            value: "UUNET (US)"
          },
          {
            key: "64.6.64.6",
            value: "Verisign (US)"
          },
          {
            key: "77.88.8.8",
            value: "77.88.8.8"
          },
          {
            key: "custom",
            value: "Custom"
          }
        ]
      }
    };
  },
  methods: {
    onChecked(option) {
      option.selected = !option.selected;
    },

    onSubmit() {
      this.$validator.validateAll().then(result => {
        let options = {};

        this.dnsOptions.forEach(o => {
          options[o.name] = o.selected;
        });

        if (result) {
          const resolver =
            this.resolver === "custom" ? this.customResolver : this.resolver;
          this.$emit("onSubmit", this.address, this.type, resolver, options);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.ping-inp {
  span {
    display: none;
  }
}
</style>

<style lang="scss" module>
@import "~@theme/scss/_variables.scss";

.left-column {
  width: 100%;
  > span,
  div[class="select"] {
    margin-bottom: 24px;
  }
}
.checkbox-wrapper {
  margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/forms/dns-tool-form/dns-tool-form.vue